// Public website hosts use their own protected API proxy; avoid cross-origin form failures.
export function websiteApiBase(configured, hostname) {
  if (['www.orrbbit.com','orrbbit.com','staging-web.orrbbit.com'].includes(hostname)) return '/api/app';
  return (configured || '/api/app').replace(/\/$/, '');
}
